import Loading from "../components/loading";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import useCustomState from "../hooks/State";
import { UpdateNavigations } from "../store/actions";
import Bill from "../components/Bill/Bill";
import Call from "../service/API";
import "../components/BillsFilter/main.css";

const BillView = (props) => {
  const isLoading = useCustomState(true);
  const billId = props.match.params.billId;
  const billInfo = useCustomState({});
  const dispatch = useDispatch();
  useEffect(() => {
    const navigations = [{ name: "مشاهده قبض", path: "/admin/show-bills" }];
    dispatch(UpdateNavigations(navigations));
    fetchBill(billId, billInfo, isLoading);
  }, []);
  return (
    <>
      {isLoading.value ? (
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          <Loading />
        </div>
      ) : (
        <Bill billInfo={billInfo} />
      )}
    </>
  );
};
export default BillView;
const fetchBill = (billId, billInfo, isLoading) => {
  const data = {
    bill_id: billId,
    bill_serial: null,
  };
  Call("POST", "bills/admin/getOne", data)
    .then((response) => {
      if (response.data.code === 200) {
        billInfo.handleChange(response.data.data);
        isLoading.handleChange(false);
      }
    })
    .catch((error) => {
      if (error.response) {
      }
    });
};
